var React   = require("react");
var Sort    = require("./sort");
var Tabs    = require("../../components/tabs");
var Filters = require('./filters');
var SuggestChallenge    = require("./challenge_suggestion");
var StageFilterSection = require('./stage_filter_section');

var RegularHeader = React.createClass({
  PropTypes: {
    challengeTypes: React.PropTypes.array.isRequired,
    selectedTabIndex: React.PropTypes.number.isRequired,
    onTabChange: React.PropTypes.func.isRequired,
    onFilterChange: React.PropTypes.func.isRequired,
    selectedChallengeFilter: React.PropTypes.object.isRequired,
    challengeStages : React.PropTypes.array.isRequired
  },

  render : function(){
    const { onTabChange, selectedTabIndex, challengeStages,
      selectedChallengeFilter, challengeTypes } = this.props;

    return (
      <div className="challenge-nav">
        <div className="challenge-nav__section challenge-nav__section--tabs">
          <StageFilterSection
            challengeTypes={challengeTypes}
            selectedTabIndex={selectedTabIndex}
            onTabChange={onTabChange}
            challengeStages={challengeStages} />
        </div>

        <div className="challenge-nav__section">
          <Filters challengeTypes={challengeTypes}
            selectedChallengeType={selectedChallengeFilter.type}
            onChange={this._onFilterChange} />
          <SuggestChallenge/>
        </div>

      </div>
    );
  },

  _onFilterChange : function(options) {
    var action = this.props.challengeStages[this.props.selectedTabIndex].action;

    this.props.onFilterChange(action, options);
  },
});

module.exports = RegularHeader;



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/regular_header.jsx